import React from 'react'
import {SVVSelect} from "./Select";
import {SVVRadioGroup} from "./RadioGroup";
import {SelectOneProps} from "./typer";

export function SVVSelectOne(
  {
    onChange,
    options,
    selected,
    legend,
    required,
    errorMessage,
    id,
    direction,
    selectSize,
    emptyChoiceText,
    name
  }: SelectOneProps) {

  return (options?.length > 5
      ? <SVVSelect
        onChange={onChange}
        options={options}
        selected={selected}
        legend={legend}
        id={id}
        required={required}
        errorMessage={errorMessage}
        selectSize={selectSize}
        emptyChoiceText={emptyChoiceText}
      />
      : <SVVRadioGroup
        onChange={onChange}
        options={options}
        selected={selected}
        legend={legend}
        required={required}
        errorMessage={errorMessage}
        id={id}
        name={name}
        direction={direction}
      />
  )
}

SVVSelectOne.displayName = "SVVSelectOne";
